<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <auto-ssl-manage />
      </gg-card>
    </v-col>
    <v-col cols="12">
      <gg-card>
        <auto-ssl-problems />
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import AutoSslProblems from '@/components/Services/Hosting/Shared/Ssl_manager/AutoSslProblems'
import AutoSslManage from '@/components/Services/Hosting/Shared/Ssl_manager/AutoSslManage'

export default {
  name: 'SslManager',
  components: {
    AutoSslProblems,
    AutoSslManage
  },
  data () {
    return {
      tab: 'manage'
    }
  },
}
</script>
